import React, { useCallback } from 'react';
import * as filestack from 'filestack-js';
import { getEnvConfig } from '@/constants';
import featureFlagStore from '@/stores/featureFlagStore';
import { FeatureFlagKeys } from '@/services/featureFlag';
import { getFilestackSecurity, invalidateFilestackSecurity, isFilestackSecurityError } from '@/utils/filestackSecurity';

// This file can be improved
export default function FilestackUploader({
  s3Path = getEnvConfig('FILESTACK_BUCKET_PATH'),
  allowManualRetry = true,
  acceptedTypes = ['video/*'],
  errorsTimeout = undefined,
  onUpload,
  children,
  ...rest
}) {
  const openPicker = useCallback(async () => {
    const options = {
      fromSources: ['local_file_system'],
      storeTo: {
        location: 's3',
        container: getEnvConfig('S3_STATIC_ASSETS_BUCKET'),
        path: s3Path,
        region: getEnvConfig('AWS_STORE_REGION')
      },
      accept: acceptedTypes,
      uploadConfig: {
        retry: 3,
        timeout: 60000
      },
      uploadInBackground: false,
      disableTransformer: true,
      maxFiles: 1,
      minFiles: 1,
      exposeOriginalFile: true,
      disableStorageKey: false,
      maxSize: 50 * 1024 * 1024, // change default size to 50MB, it used for images
      allowManualRetry,
      errorsTimeout,
      onUploadDone: (res: any) => {
        const resourceKey = encodeURIComponent(res.filesUploaded[0]?.key ?? '');
        onUpload(`${getEnvConfig('STATIC_ASSETS_CDN')}/${resourceKey}`);
      }
    };

    let security;
    const isSignedFilestackUploadsEnabled =
      featureFlagStore.getSnapshot()[FeatureFlagKeys.Use_Signed_Filestack_Uploads];
    const assetKind = acceptedTypes.some((type: string) => type.startsWith('video')) ? 'video' : 'image';
    if (isSignedFilestackUploadsEnabled) {
      ({ security } = await getFilestackSecurity({ intent: 'content_lab_root_asset', assetKind }));
    }

    const client = filestack.init(getEnvConfig('FILESTACK_API_KEY'), security ? { security } : undefined);
    client.on('upload.error', filestackError => {
      if (!isSignedFilestackUploadsEnabled || !isFilestackSecurityError(filestackError)) {
        return;
      }
      invalidateFilestackSecurity({ intent: 'content_lab_root_asset', assetKind });
    });
    const picker = client.picker(options);
    picker.open();
  }, [s3Path, allowManualRetry, acceptedTypes, errorsTimeout, onUpload]);

  return (
    <div onClick={openPicker} {...rest}>
      {children}
    </div>
  );
}
